
export default {
  namespaced: true,
  state: {
    tempLoading: false,
    tempProvider: {},
    tempService: {},
    tempAppointment: {},
    clinic: null,
    form: null,
    provider: null,
    service: null,
    systemFields: [
      { id: 'ic', field_name: 'id', enable: true },
      { id: 'PHONE', field_name: 'phone', enable: true },
      { id: 'CREATED', field_name: 'date created', enable: true },
      { id: 'EMAIL', field_name: 'email', enable: true },
      { id: 'ADDRESS', field_name: 'address', enable: true },
      { id: 'GENDER', field_name: 'gender', enable: false },
      { id: 'AGE', field_name: 'age', enable: false },
      { id: 'NICKNAME', field_name: 'nickname', enable: false },
      { id: 'OCCUPATION', field_name: 'occoupation', enable: false },
      { id: 'MARITAL_STATUS', field_name: 'marital_status', enable: false },
      { id: 'INSTAGRAM', field_name: 'instagram', enable: false },
      { id: 'FACEBOOK', field_name: 'facebook', enable: false },
      { id: 'TWITTER', field_name: 'twitter', enable: false },
      { id: 'LINKEDIN', field_name: 'linkedin', enable: false },
      { id: 'TIKTOK', field_name: 'tiktok', enable: false },
    ],
    systemProviders: ['Doctor', 'Medical Assistant'],
    customFields: [],
    appointmentFields: [
      { id: 'date', field_name: 'Date', enable: true, type: 'system' },
      { id: 'time', field_name: 'Schedule time', enable: true, type: 'system' },
      { id: 'services', field_name: 'Services', enable: true, type: 'system' },
      { id: 'provider', field_name: 'Providers', enable: true, type: 'system' },
      { id: 'paid', field_name: 'Payment', enable: true, type: 'system' },
      { id: 'contacted', field_name: 'Sent Status', enable: true, type: 'system' },
      // { id: 'responses', field_name: 'Responses', enable: true, type: 'system' },
    ],
  },
  mutations: {
    setClinic(state, data) {
      state.clinic = data
    },
    setForm(state, data) {
      state.form = data
    },
    setProvider(state, data) {
      state.provider = data
    },
    setService(state, data) {
      state.service = data
    },
    setCustomFields(state, fields) {
      state.customFields = fields ?? []
    },
    updateTempProvider(state, data) {
      state.tempProvider = { ...state.tempProvider, ...data }
    },
    updateTempService(state, data) {
      state.tempService = { ...state.tempService, ...data }
    },
    updateTempAppointment(state, data) {
      state.tempAppointment = { ...state.tempAppointment, ...data }
    },
    updateTempLoading(state, data) {
      state.tempLoading = data
    },
    resetClinic(state) {
      state.clinic = null
    },
    resetForm(state) {
      state.form = null
    },
    resetProvider(state) {
      state.provider = null
    },
    resetService(state) {
      state.service = null
    },
    resetTempProvider(state) {
      state.tempProvider = {}
    },
    resetTempService(state) {
      state.tempService = {}
    },
    resetTempAppointment(state) {
      state.tempAppointment = {}
    },
  },
  getters: {
    getClinic(state) {
      return state.clinic
    },
    getForm(state) {
      return state.form
    },
    getProvider(state) {
      return state.provider
    },
    getService(state) {
      return state.service
    },
    getTempProvider(state) {
      return state.tempProvider
    },
    getTempService(state) {
      return state.tempService
    },
    getTempAppointment(state) {
      return state.tempAppointment
    },
    getTempLoading(state) {
      return state.tempLoading
    },
    getSystemProviders(state) {
      return state.systemProviders
    },
    getAllFields (state) {
      const fields = [...state.systemFields, ...state.customFields]
      const savedFields = JSON.parse(localStorage.getItem('yz_patient_fields'))
      if (savedFields) {
        fields.map(field => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAppointmentFields(state) {
      const fields = state.appointmentFields
      const savedFields = JSON.parse(localStorage.getItem('yz_appointment_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getReviewInvitationFields(state) {
      const fields = state.reviewInvitationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_clinic_review_invitation_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
  },
}